export default "<div class=\"chart-container\">\n    <div class=\"chart\"></div>\n</div>";